import {ONE_TRUST_COOKIE_LIST_ID_MAP} from "shared/Utils/Constants";

const MAX_RETRIES = 4;
const POLLING_INTERVAL = 400;
/* 400 * 5 == 2000ms */

const pollForActiveGroups = async (retries = 0) => {
    const activeGroups = window.OnetrustActiveGroups ? window.OnetrustActiveGroups : "";
    if (activeGroups || retries >= MAX_RETRIES) {
        return activeGroups;
    }
    await new Promise(resolve => setTimeout(resolve, POLLING_INTERVAL));
    return pollForActiveGroups(retries + 1);
};

export const getConsents = async () => {
    try {
        const acceptedConsents = [];
        const activeGroups = await pollForActiveGroups();

        for (const cookieId in ONE_TRUST_COOKIE_LIST_ID_MAP) {
            if (activeGroups.includes(cookieId)) {
                acceptedConsents.push(ONE_TRUST_COOKIE_LIST_ID_MAP[cookieId]);
            }
        }
        return acceptedConsents;
    } catch (error) {
        return [];
    }
};
